import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Stock } from '../models/stock';
import { environment } from '../../environments/environment';

@Injectable()
export class StockService {

  constructor(private httpClient: HttpClient) { }

  getStock(): Observable<Stock[]> {
    return this.httpClient.get<Stock[]>(environment.apiBaseUrl + '/stock/');
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/services/stock.service.ts